<template>
    <router-view />

</template>

<script>
import { defineComponent } from 'vue';
import './assets/css/style.css'
import '@/assets/css/themes.css'
export default defineComponent({
name: 'App'
});
</script>

<style>

#app {
height: 100%;
}
</style>
